function validate () {}

validate.prototype.phone = (text) => {
    const reg = /^1[3456789]\d{9}$/;
    return reg.test(text);
}
validate.prototype.company = (text) => { // 汉子数字字母下划线
    const reg = /^[\u4E00-\u9FA5a-zA-Z0-9_]{1,30}$/;
    return reg.test(text);
}
let mw_validate = new validate()

/* 访问接口地址 可变 */
const baseUrl =  {
    crm: 'http://114.113.152.67:9595', // http://crm.chinatsi.net
    sso: 'http://114.113.152.67:8080/crm-sso', //http://118.126.142.55:8080/crm-sso
    online: 'http://118.126.142.187:8088/online',
    cyw: 'http://114.113.152.67:9090', // 192.168.0.16
    service: 'https://service.chinatsi.net',
    modify: 'http://114.113.152.67:8118',
    business: 'https://api.chinatsi.net', // 报价/商情 https://api.chinatsi.net http://118.126.142.55:9292
    business2: 'http://118.126.142.187:8089', // 报价/商情
    informationFF: 'https://tangsong.chinatsi.net', // 新加的资讯详情富文本获取接口
    informationShare: 'http://tsgtapp.chinatsi.cn'
}

/* 页面链接，可变 */
const navigationUrl = {
    '首页': '/index/39',
    '资讯': '/home/information/47',
    '研报': '/home/report/48',
    '价格指数': '/home/priceIndex/49',
    '基准价': '/home/basePrice/50',
    '报价': '/home/modifyPrice/51',
    '期现': '/home/currentCash/52',
    '钢坯调期': '/home/billetAdjustment/53',
    '数据': '/home/record/54',
    '服务体系': '/serviceSystem',
    '关于我们': '/aboutUs',
    '网站地图': '/home/siteMap',
    '意见反馈': '/home/feedback',
    '企业报价': '/home/quote',
    '商情': '/home/tradeNews',
    '会员中心': '/home/selfPage',
    '峰会频道': '/home/activities'
}

/* 研报分类 */
const reportClassify = {
    '唐宋100指数报告-分品种': '品种分析',
    '唐宋100指数（周）报告': '市场分析',
    '唐尔街日报': '唐尔街日报',
    '监测预警周报': '行业视点'
}

/* 广告位id */
const adIDs = {
    'indexRow': 22,
    'indexSwiper': 2, // 首页轮播广告图
    'indexLeft1': 23,
    'indexRight1': 19, // 首页
    'indexRight2': 20, // 首页
    'indexRight3': 21, // 首页
    // 首页
    'B': 26,
    'C': 27,
    'D': 28,
    'E': 29,
    'F': 31,
    'jzjA': 30,
    'jzjC': 32,
    'qybj': 33,
    'qysq': 34,
    'zxleft': 35,
    'ybleft': 36,
    'zsleft': 37,
    'gptq46': 46,
    'tj45': 45,
    'jzj44': 44,
    'yb43': 43,
    'yb42': 42,
    'yb41': 41,
    'zx40': 40,
    'zx39': 39,
    'zx55': 55,
    'index38': 38,
    'index47': 47,
    'index48': 48,
    'index51': 51,
    'index52': 52,
    'index53': 53,
    'yb49': 49,
    'zsright1': 54,
    'zstonglan2': 57,
    'tjright1': 58,
    'qxtonglan1': 59,
    'index60': 60,
    'tjleft1': 61,
	'index62':62
}

/* 获取页面参数 */
const getQueryString = (param) => {
    let obj = {};
    let name, value;
    let str = location.href; //取得整个地址栏
    let num = str.indexOf("?")
    str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

    let arr = str.split("&"); //各个参数放到数组里
    for(let i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if(num > 0) {
            name = arr[i].substring(0, num);
            value = arr[i].substr(num + 1);
            obj[name] = value;
        }
    }
    return obj[param];
}


/* 取近三天的日期和星期 */
const getThreeDays = (date) => { // 快讯近三天的
    const weekdayArr = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
    let stamp;
    if (date) {
        stamp = new Date(date);
    } else {
        stamp = new Date();
    }
    let lastStamp1 = stamp.getTime() - 86400000;
    lastStamp1 = new Date(lastStamp1);
    let lastStamp2 = stamp.getTime() - (86400000*2);
    lastStamp2 = new Date(lastStamp2);
    let year = stamp.getFullYear();
    let month = stamp.getMonth() + 1;
    let day = stamp.getDate();
    month = month < 10 ? ('0' + month) : month;
    day = day < 10 ? ('0' + day) : day;
    let weekday = stamp.getDay();
    let year1 = lastStamp1.getFullYear();
    let month1 = lastStamp1.getMonth() + 1;
    let day1 = lastStamp1.getDate();
    month1 = month1 < 10 ? ('0' + month1) : month1;
    day1 = day1 < 10 ? ('0' + day1) : day1;
    let weekday1 = lastStamp1.getDay();
    let year2 = lastStamp2.getFullYear();
    let month2 = lastStamp2.getMonth() + 1;
    let day2 = lastStamp2.getDate();
    month2 = month2 < 10 ? ('0' + month2) : month2;
    day2 = day2 < 10 ? ('0' + day2) : day2;
    let weekday2 = lastStamp2.getDay();
    let days = [];
    days.push({date: `${year}-${month}-${day}`, week: weekdayArr[weekday], list: []})
    days.push({date: `${year1}-${month1}-${day1}`, week: weekdayArr[weekday1], list: []})
    days.push({date: `${year2}-${month2}-${day2}`, week: weekdayArr[weekday2], list: []})
    return days
}

export { mw_validate, baseUrl, navigationUrl, reportClassify, adIDs, getThreeDays, getQueryString }